module.exports = __webpack_public_path__ + "static/g1-7de16c3ae67b9316029e003306c0777d.jpg";